<template>
    <Modal @close="close" :class="$style.jobDescModal">
        <template #content>
            <JobDescription :job="job"/>
        </template>
    </Modal>
</template>

<script>
import { Button } from '@applied/marmot'
import JobDescription from '../JobDescription.vue'
import Modal from '@/components/Modal/Modal.vue'

export default {
    name: 'JobDescriptionModal',
    components: {
        Button,
        Modal,
        JobDescription,
    },
    props: {
        job: {
            type: Object,
            required: true,
        }
    },
    methods: {
        close() {
            this.$emit('close')
        },
    }
}
</script>

<style module src="./JobDescriptionModal.css" />